module.exports = __webpack_public_path__ + "static/img/ntfbox3.809a9c55.png";